import type { ReactNode } from "react";
import type { StepDeckItem } from "./gtm-step-deck";
import { IntelShell } from "./intel-shell";
import { IntelSectionNav } from "./intel-top-nav";
import { EmptyPanel } from "./shared-bits";
import { WORKSPACE_ACCENT } from "./workspaces";

// A finished-but-gated section rendered in the FULL new UI: the same dark
// observatory shell + command-bar header (mono eyebrow → serif head with one
// italic accent word → one-line lede) every redesigned section carries, with a
// single quiet dashed panel where the (sign-off-gated) data will land — the very
// same `EmptyPanel` the live section shows when it has no rows. So a gated
// section looks like the redesign, never the old `SectionHeader` placeholder.
// Purely presentational: no data is fetched and nothing is un-gated.
const COMING_SOON_STEPS: StepDeckItem[] = [{ key: "overview", label: "Coming soon" }];

export function ComingSoonSection({
  id,
  n,
  kicker,
  head,
  lede,
  accent = WORKSPACE_ACCENT["demand-signals"],
  note = "This section is coming soon.",
}: {
  id: string;
  n: string;
  kicker: string;
  head: ReactNode;
  lede: ReactNode;
  accent?: string;
  note?: string;
}) {
  return (
    <IntelShell id={id} accent={accent}>
      <IntelSectionNav
        steps={COMING_SOON_STEPS}
        active={0}
        onSelect={() => {}}
        n={n}
        kicker={kicker}
        head={head}
        lede={lede}
        accent={accent}
      />
      <div style={{ marginTop: 24 }}>
        <EmptyPanel>{note}</EmptyPanel>
      </div>
    </IntelShell>
  );
}
